import Pusher from "pusher-js";

export const pusher = new Pusher("c288d78836ac4c765407", {
  cluster: "ap2",
});
